












import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getScrollParent } from "@/utils";

@Component({})
export default class NavigablePane extends Vue {
  private container: HTMLElement | null = null;

  private elements: HTMLElement[] = [];

  private before: HTMLElement[] = [];

  private after: HTMLElement[] = [];

  private observer?: MutationObserver;

  @Prop()
  private selector!: string;

  @Watch("selector")
  update() {
    this.elements = [
      ...this.$el.querySelectorAll(this.selector)
    ] as HTMLElement[];
    this.callback();
  }

  callback() {
    const rect = this.container && this.container.getBoundingClientRect();

    this.before = this.elements.filter(
      element => rect && element.getBoundingClientRect().top < rect.top
    );
    this.after = this.elements.filter(
      element =>
        rect &&
        element.getBoundingClientRect().top +
          element.getBoundingClientRect().height >
          rect.top + rect.height
    );
  }

  mounted() {
    this.$nextTick(() => {
      this.container = getScrollParent(this.$el) as HTMLElement;
      this.container.addEventListener("scroll", this.callback);

      this.observer = new MutationObserver(this.update);
      this.update();

      if (this.$slots.default) {
        this.$slots.default.forEach(
          slot =>
            slot.elm &&
            this.observer &&
            this.observer.observe(slot.elm, {
              childList: true,
              attributes: true,
              subtree: true
            })
        );
      }
    });
  }

  destroyed() {
    if (this.container)
      this.container.removeEventListener("scroll", this.callback);
    if (this.observer) this.observer.disconnect();
  }
}
